module.exports = __webpack_public_path__ + "img/cube.416a133a.png";